import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Upload } from "antd";
import React from "react";
import { colors } from "../../styles/colors";
import { errorMessage, successMessage } from "../../messages/messages";
import { urlDeUpload } from "../../services/apiDocumentos";

import keycloak from "../../keycloak.js";

interface IProps {
  setChave: React.Dispatch<React.SetStateAction<number | undefined>>;
  identificador: boolean;
  label?: string;
}

export const SelecionarArquivo = ({ setChave, identificador, label }: IProps) => {
      const token = keycloak.token;

  const subirArquivo = {
    name: "file",
    action: urlDeUpload,
    headers: {
      Authorization: `Bearer ${token}` as string,
    },
    showUploadList: {
      showRemoveIcon: false,
    },
    onChange(info: any) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        successMessage(`Arquivo ${info.file.name} carregado com sucesso.`);
        setChave(info.file.response.idDocumento);
      } else if (info.file.status === "error") {
        errorMessage(`Falha no carregamento do arquivo ${info.file.name}.`);
      }
    },
  };
  return (
    <Form.Item
    valuePropName={"filelist"} 
      label={label === undefined ? "Documento" : label}
      name="documento"
      colon={false}
      rules={[
        {
          required: identificador ? false : true,
          message: identificador ? "" : "Documento obrigatório não preenchido",
        },
      ]}
    >
      <Upload {...subirArquivo} accept=".pdf" maxCount={1}>
        <Button
          id="selecionarArquivoObrigatorio"
          type="dashed"
          shape="round"
          style={{ color: colors.main }}
          icon={<UploadOutlined />}
        >
          Selecione o(s) Arquivo(s)
        </Button>
      </Upload>
    </Form.Item>
  );
};
